import { IMedia } from '../../interfaces/nonprofitProfile/iMedia';

export class Media implements IMedia {
	url: string;
	title: string;

	constructor(media: IMedia = {} as IMedia) {
		this.title = media.title;
		this.url = media.url;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/nonprofitProfile/media.ts